export const SET_AUTH_DATA = 'SET_AUTH_DATA';
export const SET_USER_INFO = 'SET_USER_INFO';
